<template>
  <!-- 外層容器：3D 效果 -->
  <div class="register-container" ref="registerBlock">
    <nav class="breadcrumb">
    <router-link to="/login">會員登入</router-link> &gt;
    <span>註冊</span>
    </nav>
    <!-- 主要卡片：左右分佈 (類似 contact-card) -->
    <div class="register-card">
      <!-- 左側：品牌介紹 / 步驟指示 / 或放圖片 -->
      <div class="register-left">
        <!-- 可放品牌 Logo、簡介、或大圖  -->
        <h1>歡迎加入 {{$Settings.COMPANY_NAMEN}}</h1>
        <p>只要二步驟，即可完成註冊，立即享受更多會員專屬優惠！</p>

        <!-- 步驟指示器 -->
        <div class="step-indicator">
          <div :class="['step-item', { active: step === 1 }]">
            <span>1</span> 驗證手機
          </div>
          <div :class="['step-item', { active: step === 2 }]">
            <span>2</span> 設定帳密
          </div>
        </div>
      </div>

      <!-- 右側：表單容器 (含兩步驟) -->
      <div class="register-right form-block">
        <!-- 快速註冊 (Google / LINE) -->
        <div class="quick-register">
          <p class="quick-register-title">快速註冊 (免填表單)</p>
          <div class="quick-register-buttons">
            <button class="social-btn google-btn" type="button" @click="handleGoogleLogin">
              <svg class="NEH9Ef" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 40 48" aria-hidden="true">
                <path fill="#4285F4"
                  d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z" />
                <path fill="#34A853"
                  d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z" />
                <path fill="#FABB05"
                  d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z" />
                <path fill="#E94235"
                  d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z" />
              </svg>
              Google
            </button>
            <button class="social-btn line-btn" type="button" @click="handleLineLogin">
              <svg class="floating-icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.7228 9.225V13.0339C14.7228 13.1304 14.6478 13.2054 14.5514 13.2054H13.9406C13.8817 13.2054 13.8281 13.1732 13.8014 13.1357L12.0549 10.7786V13.0393C12.0549 13.1357 11.9799 13.2107 11.8835 13.2107H11.2728C11.1764 13.2107 11.1014 13.1357 11.1014 13.0393V9.23036C11.1014 9.13393 11.1764 9.05893 11.2728 9.05893H11.8781C11.9317 9.05893 11.9906 9.08572 12.0174 9.13393L13.7639 11.4911V9.23036C13.7639 9.13393 13.8389 9.05893 13.9353 9.05893H14.546C14.6424 9.05357 14.7228 9.13393 14.7228 9.225ZM10.3299 9.05357H9.71921C9.62278 9.05357 9.54778 9.12857 9.54778 9.225V13.0339C9.54778 13.1304 9.62278 13.2054 9.71921 13.2054H10.3299C10.4264 13.2054 10.5014 13.1304 10.5014 13.0339V9.225C10.5014 9.13393 10.4264 9.05357 10.3299 9.05357ZM8.85671 12.2464H7.19064V9.225C7.19064 9.12857 7.11564 9.05357 7.01922 9.05357H6.4085C6.31207 9.05357 6.23707 9.12857 6.23707 9.225V13.0339C6.23707 13.0821 6.25314 13.1196 6.28529 13.1518C6.31743 13.1786 6.35493 13.2 6.40314 13.2H8.85136C8.94778 13.2 9.02278 13.125 9.02278 13.0286V12.4179C9.02278 12.3268 8.94779 12.2464 8.85671 12.2464ZM17.9371 9.05357H15.4888C15.3978 9.05357 15.3174 9.12857 15.3174 9.225V13.0339C15.3174 13.125 15.3924 13.2054 15.4888 13.2054H17.9371C18.0335 13.2054 18.1085 13.1304 18.1085 13.0339V12.4232C18.1085 12.3268 18.0335 12.2518 17.9371 12.2518H16.271V11.6089H17.9371C18.0335 11.6089 18.1085 11.5339 18.1085 11.4375V10.8214C18.1085 10.725 18.0335 10.65 17.9371 10.65H16.271V10.0071H17.9371C18.0335 10.0071 18.1085 9.93215 18.1085 9.83572V9.225C18.1031 9.13393 18.0281 9.05357 17.9371 9.05357ZM24.146 4.37679V19.6607C24.1406 22.0607 22.1746 24.0053 19.7692 24H4.48529C2.08529 23.9946 0.14065 22.0232 0.146007 19.6232V4.33929C0.151364 1.93929 2.12279 -0.0053461 4.52279 1.10419e-05H19.8067C22.2067 0.00536818 24.1513 1.97144 24.146 4.37679ZM20.846 10.9446C20.846 7.03393 16.9246 3.85179 12.1085 3.85179C7.29243 3.85179 3.371 7.03393 3.371 10.9446C3.371 14.4482 6.47814 17.3839 10.6781 17.9411C11.7014 18.1607 11.5835 18.5357 11.3531 19.9125C11.3156 20.1321 11.1764 20.775 12.1085 20.3839C13.0406 19.9928 17.1388 17.4214 18.9763 15.3107C20.2406 13.9179 20.846 12.5089 20.846 10.9446Z" fill="currentColor"></path></svg>
              LINE
            </button>
          </div>
        </div>

        <div class="divider"><span>或 手機號碼註冊</span></div>

        <!-- 卡片：步驟一：手機驗證 -->
        <div class="step-card" v-if="step === 1">
          <h2>步驟 1：手機驗證</h2>
          <div class="tooltip-container">
            <label for="phone">手機電話</label>
            <!-- <span class="tooltip-text">
              台灣請使用：0912345678<br />
              海外請加區碼：(香港) +852 12345678
            </span> -->
            <input type="text" id="phone" inputmode="numeric" v-model="phone" placeholder="0912345678" :readonly="isCodeVerified"
              :disabled="isCodeSent" required />
          </div>
          <div v-if="phoneMessage" class="error-message">{{ phoneMessage }}</div>

          <div v-if="!isCodeVerified">
            <button type="button" :disabled="isCodeSent" @click="sendVerificationCode">
              {{ isCodeSent ? `${countdown} 秒後可重新發送` : '發送驗證碼' }}
            </button>
          </div>

          <div v-if="isCodeSent && !isCodeVerified" class="verification-section">
            <label for="verificationCode">驗證碼</label>
            <input inputmode="numeric" type="text" id="verificationCode" name="no-autofill"  maxlength="6" v-model="verificationCode" required />
            <p v-if="verificationMessage" class="error-message">
              {{ verificationMessage }}
            </p>
            <button type="button" @click="verifyCode">確認驗證碼</button>
          </div>
        </div>

        <!-- 卡片：步驟二：設定密碼 -->
        <div class="step-card" v-if="step === 2">
          <h2>步驟 2：設定帳密</h2>
          <div>
            <label for="dphone">會員帳號</label>
            <input type="text" id="dphone" v-model="phone" disabled />
          </div>
          <!-- <div>
            <label for="account">會員帳號</label>
            <input type="text" id="account" v-model="account" required />
          </div>
          <div>
            <label for="username">會員姓名</label>
            <input type="text" id="username" v-model="username" required />
          </div> -->
          <div>
            <label for="password">密碼</label>
            <input type="password" id="password" v-model="password" required />
          </div>
          <div>
            <label for="confirmPassword">密碼確認</label>
            <input type="password" id="confirmPassword" v-model="confirmPassword" required />
          </div>
          <p v-if="verificationPassMessage" class="error-message">{{ verificationPassMessage }}</p>

          <button type="button" :disabled="!isRegisterEnabled()" @click="register">
            註冊
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'RegisterPage',
  data() {
    return {
      step: 1,
      phone: '',
      //  account: '',
      //  username: '',
      password: '',
      confirmPassword: '',
      verificationCode: '',
      verificationMessage: '',
      verificationPassMessage: '',
      phoneMessage: '',
      isCodeSent: false,
      isCodeVerified: false,
      countdown: 0
    };
  },
  computed: {
    ...mapGetters(['imagePath'])
  },
  watch: {
    // account: 'updateVerificationAccountMessage',
    password: 'updateVerificationMessage',
    confirmPassword: 'updateVerificationMessage'
  },
  methods: {
    ...mapMutations(['setLoggedIn', 'setUserProfile']),
    randomState() {
      const randomBytes = new Uint8Array(20);
      window.crypto.getRandomValues(randomBytes);
      return encodeURIComponent(
        Array.from(randomBytes).map((b) => b.toString(16).padStart(2, '0')).join('')
      );
    },
    handleGoogleLogin() {
      const clientId = process.env.VUE_APP_GOOGLE_CODE;
      const redirectUri = encodeURIComponent(process.env.VUE_APP_GOOGLE_REDIRECT_URL);
      const scope = encodeURIComponent('email profile');
      const state = this.randomState();
      axios.post('/api/login/state-save', { state }).then((res) => {
        if (res.data.success) {
          window.location.href =
            'https://accounts.google.com/o/oauth2/v2/auth' +
            `?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&response_type=code`;
        }
      }).catch((error) => console.error(error));
    },
    handleLineLogin() {
      const clientId = process.env.VUE_APP_LINE_CLIENT_ID;
      const redirectUri = encodeURIComponent(process.env.VUE_APP_LINE_REDIRECT_URL);
      const scope = encodeURIComponent('openid profile email');
      const state = this.randomState();
      axios.post('/api/login/state-save', { state }).then((res) => {
        if (res.data.success) {
          window.location.href =
            'https://access.line.me/oauth2/v2.1/authorize' +
            `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scope}&bot_prompt=normal&prompt=consent`;
        }
      }).catch((error) => console.error(error));
    },
    // 驗證帳號/密碼 是否符合規則
    isRegisterEnabled() {
      // if (this.account.length === 0) return false;
      // if (!/^[a-zA-Z0-9]{6,}$/.test(this.account)) return false;
      if (this.password.length === 0) return false;
      if (this.password !== this.confirmPassword) return false;
      // if (this.password === this.account) return false;
      if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.password)) return false;
      return true;
    },
    // updateVerificationAccountMessage() {
    //   if (this.account.length === 0) {
    //     this.verificationPassMessage = "帳號不能為空";
    //   } else if (!/^[a-zA-Z0-9]{6,}$/.test(this.account)) {
    //     this.verificationPassMessage = "帳號必須至少6位且只包含字母和數字";
    //   } else if (this.password === this.account) {
    //     this.verificationPassMessage = "帳號與密碼不能相同";
    //   } else {
    //     this.verificationPassMessage = '';
    //   }
    // },
    updateVerificationMessage() {
      if (this.password.length === 0) {
        this.verificationPassMessage = "密碼不能為空";
      } else if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.password)) {
        this.verificationPassMessage = "密碼必須至少6位且包含一個小寫字母和一個數字";
      } else if (this.password !== this.confirmPassword) {
        this.verificationPassMessage = "密碼與確認密碼不匹配";
      } else {
        this.verificationPassMessage = '';
      }
    },
    async register() {
      if (!this.isRegisterEnabled()) {
        alert('提供的資料無效或不完整');
        return;
      }
      try {
        // 讀取合作夥伴推廣碼（若客人是透過專屬連結進來的），註冊當下就綁定夥伴
        let refCode = null;
        try {
          const stored = localStorage.getItem('affiliateRef');
          if (stored) refCode = JSON.parse(stored).code || null;
        } catch (e) { /* ignore */ }
        const res = await axios.post('/api/user/register', {
          //account: this.account,
          // username: this.username,
          phone: this.phone,
          password: this.password,
          ref_code: refCode
        });
        if (res.data.success) {
          console.log(res.data.user);
          this.setLoggedIn(true);
          this.setUserProfile(res.data.user);
          this.$router.push('/profile');
        } else {
          this.verificationPassMessage = res.data.message;
        }
      } catch (error) {
        console.error(error);
        alert('註冊過程中發生錯誤');
      }
    },
    async sendVerificationCode() {
      if (!this.phone) {
        this.phoneMessage = '請輸入手機號碼！';
        return;
      }
      const taiwanPhoneRegex = /^09\d{8}$/;
      const internationalPhoneRegex = /^\+\d{1,4}\s?\d{6,12}$/;
      if (!taiwanPhoneRegex.test(this.phone) && !internationalPhoneRegex.test(this.phone)) {
        this.phoneMessage = `請輸入有效的手機號碼：\n台灣手機範例：0912345678`;
        return;
      }
      try {
        const res = await axios.post('/api/phone/sendcode', {
          type: 'register',
          phone: this.phone
        });
        if (res.data.success) {
          this.isCodeSent = true;
          this.phoneMessage = '';
          this.countdown = res.data.outtime;
          const interval = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              this.isCodeSent = false;
              clearInterval(interval);
            }
          }, 1000);
        } else {
          this.phoneMessage = (res.data.message || '發送失敗');
        }
      } catch (err) {
        this.phoneMessage = err.response?.data?.message || '伺服器錯誤，請稍後再試';
      }
    },
    async verifyCode() {
      if (!this.verificationCode) {
        this.verificationMessage = '請輸入驗證碼！';
        return;
      }
      try {
        const res = await axios.post('/api/phone/verifycode', {
          code: this.verificationCode,
          phone: this.phone
        });
        if (res.data.success) {
          this.step = 2;
        } else {
          this.verificationMessage = '無法找到驗證碼或驗證碼已過期。';
        }
      } catch (error) {
        this.verificationMessage = '驗證失敗，請重試！';
      }
    }
  },
  mounted() {
    // IntersectionObserver：讓整個卡片有淡入 & 3D翻轉一點點
    const container = this.$refs.registerBlock;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("container-visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(container);
  }
};
</script>

<style scoped>
/* 外層容器：與 contact-container 類似 */
.register-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  opacity: 0;
  transform: translateY(50px) rotateX(8deg);
  transform-origin: top;
  transition: opacity 1.2s ease, transform 1.2s ease;
  perspective: 800px;
  /* 父容器的3D視角 */
}

.register-container.container-visible {
  opacity: 1;
  transform: translateY(0) rotateX(0);
}

/* 卡片樣式：與 contact-card 類似 */
.register-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;

  background-color: #f9f9f9;
  /* 淡灰背景 */
  border-radius: 10px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;

  /* 動畫預設：先淡出下移 */
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.container-visible .register-card {
  opacity: 1;
  transform: translateY(0);
}

/* 左右區塊 */
.register-left,
.register-right {
  flex: 1;
  min-width: 300px;
}

/* 左側 */
.register-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.register-left h1 {
  margin-bottom: 10px;
}

.register-left p {
  line-height: 1.6;
}

.intro-image {
  width: 100%;
  max-width: 220px;
  margin-top: 20px;
  object-fit: cover;
  border: 5px solid #fff;
  border-radius: 10px;
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
  transform: rotateX(10deg);
  transform-origin: center bottom;
}

.intro-image:hover {
  transform: rotateX(0deg);
}

/* 右側 */
.register-right {
  display: flex;
  flex-direction: column;
}

/* step-indicator, step-item */
.step-indicator {
  display: flex;
  margin: 15px 0;
}

.step-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
  color: #999;
}

.step-item span {
  background-color: #999;
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}

.step-item.active {
  color: #007bff;
}

.step-item.active span {
  background-color: #007bff;
}

/* 兩步驟區塊 */
.step-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: left;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* Tooltip */
.tooltip-container {
  position: relative;
  margin-bottom: 15px;
}

.tooltip-text {
  visibility: hidden;
  width: 300px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 8px;
  border-radius: 4px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

/* input + error messages */
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}


/* 按鈕 */
button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.form-block {
  max-width: 400px;
  /* 自行調整合適的寬度 */
  margin: 0 auto;
  /* 置中 */
  text-align: left;
  /* 可依喜好，或用 .form-group 內再做排版 */
  /* 其他想要的背景/陰影等 */
}


.form-group {
  margin-bottom: 15px;
}

.form-block input,
.form-block select,
.form-block textarea {
  width: 100%;
  box-sizing: border-box;
  /* 避免 padding 撐大 */
  /* 其他 styling, 如 padding, border, font-size */
}

/* 快速註冊區 */
.quick-register {
  text-align: center;
  margin-bottom: 10px;
}
.quick-register-title {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 10px;
}
.quick-register-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.social-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  color: #fff;
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.social-btn:hover {
  transform: scale(1.05);
}
.google-btn {
  background-color: #db4437;
}
.line-btn {
  background-color: #00c300;
}
.social-btn svg {
  width: 20px;
  height: 20px;
}

/* 分隔線 */
.divider {
  display: flex;
  align-items: center;
  margin: 16px 0;
}
.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #ddd;
}
.divider span {
  padding: 0 12px;
  color: #999;
  font-size: 0.85rem;
  white-space: nowrap;
}

/* RWD：手機板時改為上下堆疊 */
@media (max-width: 768px) {
  .register-card {
    flex-direction: column;
  }
}


</style>
